import { Component, OnInit } from '@angular/core';
import { EventService } from 'src/app/services/event.service';
import { Event } from 'src/app/model/event';

@Component({
  selector: 'dashboard',
  templateUrl: 'dashboard.html'
})

export class DashboardComponent implements OnInit {
  private events: Event[] = [];

  constructor(private readonly eventService: EventService) { }

  ngOnInit() {
    this.eventService.getEvents().subscribe(events => {
      this.events = events.filter(event => new Date(event.date).getTime() < new Date().getTime() && event.report && !event.eventRepetitionId)
        .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
        .slice(0, 5);
    })
  }
}